export const utilsObj = {
    getUnknownOrYesOrNo(value) {
        if (value == 0) {
            return "未知";
        } else if (value == 1) {
            return "是";
        } else {
            return "否";
        }
    },
    getYesOrNo(value) {
        if (value == 0) {
            return "否";
        } else {
            return "是";
        }
    },
    getYesOrNoEx(value) {
        if (value == 0) {
            return "是";
        } else {
            return "否";
        }
    },
    //车位等级
    carSetLev() { return ["A", "B", "C", "D", "E", "F"] },
    //根据index获取车位类型
    getCarSetLev(index) {
        let ret = "-";
        if (this.carSetLev()[index]) {
            ret = this.carSetLev()[index];
        }
        return ret;
    },
    //审核状态
    audiotState() { return ["未审核", "政委审核通过", "政委审核拒绝", "经理待审核", "经理审核通过", "经理审核拒绝"] },
    //根据index获取审核状态
    getAudiotState(index) {
        let ret = "-";
        if (this.audiotState()[index]) {
            ret = this.audiotState()[index];
        }
        return ret;
    },
    //签约状态
    signState() { return ["未签约", "不可售", "已签约"] },
    //根据index获取签约状态
    getSignState(index) {
        let ret = "-";
        if (this.signState()[index]) {
            ret = this.signState()[index];
        }
        return ret;
    },
    getD(a, b) {  //获取两个时间相差月
        var arrA = a.split("-"),
            arrB = b.split("-"),
            yearA = arrA[0],
            yearB = arrB[0],
            monthA = +arrA[1],
            monthB = (yearB - (+yearA)) * 12 + parseInt(arrB[1]),
            rA = [],
            rB = [];
        do {
            do {
                rA.push(yearA + "" + (monthA > 9 ? monthA : "0" + monthA));
                rB.push(yearA + "年" + monthA + "月");
                if (monthA == 12) {
                    monthA = 1;
                    monthB -= 12;
                    break;
                }
            } while (monthB > monthA++)
        } while (yearB > yearA++)
        return [rA, rB];
    },
    getDateFormat(dateStr) {
        if (dateStr) {
            var dateArray = dateStr.split(" ");
            return dateArray[0];
        } else {
            return "";
        }
    },
    //生成guid
    guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },
    //保存手机本地数据
    saveLocation(key, value) {
        SXApi.call(
            function (suc) {
            },
            null,
            "FunctionPlugin",
            "save_location",
            {
                key: key,
                value: value
            }
        );
    },
    //获取手机本地信息
    getLocation(key, callback) {
        SXApi.call(
            function (suc) {
                callback(suc.data.data)
            },
            null,
            "FunctionPlugin",
            "get_location",
            {
                key: key
            }
        );
    },
    isNull(value) {
        if (value === null || value === "" || value === undefined || value === "undefined") {
            return true;
        }
        return false;
    },
    //是否是url地址
    isUrlAddress(url) {
        return url.indexOf("http")!=-1;
    
        // var reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+).)+([A-Za-z0-9-~\/])+$/;
        // return reg.test(url);
    },
    //上传文件类型
    fileTypeMap() {
        return [
            { val: 1, value: "项目分析" },
            { val: 7, value: "回复函" },
            { val: 2, value: "拓展复盘" },
            { val: 3, value: "同行学习" },
            { val: 4, value: "同行复盘" },
            { val: 10, value: "数据表" },
            { val: 11, value: "销控图" },
            { val: 12, value: "我方车位库存明细表" },
            { val: 17, value: "甲方车位库存明细表" },
            { val: 24, value: "剩余车位库存明细表" },
            { val: 13, value: "承诺书" },
            { val: 15, value: "我方销售台账" },
            { val: 16, value: "甲方销售台账" },
            { val: 19, value: "方案" },
            { val: 23, value: "前期销售合同" },
            { val: 25, value: "商务函" },
            { val: 26, value: "业主明细" },
            { val: 27, value: "业主签约合同模板" },
            { val: 28, value: "续签项目评估表" },
            { val: 29, value: "车位库存明细表" },
            { val: 30, value: "车位销售台账" },
            { val: 31, value: "其他" },
        ]
    },
    //获取上传文件类型
    getNameByfileType(val) {
        let ret = "";
        let tempMap = this.fileTypeMap();
        for (let i = 0; i < tempMap.length; i++) {
            if (val == tempMap[i].val) {
                ret = tempMap[i].value;
                break;
            }
        }
        return ret;
    },
    //上传文件类型所有
    fileTypeMapEx() {
        return [
            { val: 1, value: "项目分析" },
            { val: 7, value: "回复函" },
            { val: 2, value: "拓展复盘" },
            { val: 3, value: "同行学习" },
            { val: 4, value: "同行复盘" },
            { val: 5, value: "经理复盘" },
            { val: 6, value: "最终销售价格表" },
            { val: 8, value: "三方确认函" },
            { val: 9, value: "撤场确认函" },
            { val: 10, value: "数据表" },
            { val: 11, value: "销控图" },
            { val: -100, value: "开发商相关文件" },
            { val: 12, value: "我方车位库存明细表" },
            { val: 17, value: "甲方车位库存明细表" },
            { val: 24, value: "剩余车位库存明细表" },
            { val: 13, value: "承诺书" },
            { val: 14, value: "广告策略" },
            { val: 15, value: "我方销售台账" },
            { val: 16, value: "甲方销售台账" },
            { val: -99, value: "资源相关文件" },
            { val: 19, value: "方案" },
            { val: 21, value: "居间协议" },
            { val: 22, value: "同行商务条款" },
            { val: 23, value: "前期销售合同" },
            { val: 25, value: "商务函" },
            { val: 26, value: "业主明细" },
            { val: 27, value: "业主签约合同模板" },
            { val: 28, value: "续签项目评估表" },
            { val: 29, value: "车位库存明细表" },
            { val: 30, value: "车位销售台账" },
            { val: 31, value: "其他" },
        ]
    },
    //获取上传文件类型所有
    getNameByfileTypeEx(val) {
        let ret = "";
        let tempMap = JSON.parse(JSON.stringify(this.fileTypeMapEx()));
        tempMap.push({ val: 20, value: "撤场回复函" });
        for (let i = 0; i < tempMap.length; i++) {
            if (val == tempMap[i].val) {
                ret = tempMap[i].value;
                break;
            }
        }
        return ret;
    },
    //是否使用手机端
    isPhone() {
        if (navigator.userAgent.indexOf("os-name/android") == -1) {
            return false
        } else {
            return true
        }
    },
    //获取职位类型
    jobMap() {
        return [
            { val: 0, value: "老板" },
            { val: 1, value: "股东" },
            { val: 2, value: "总裁" },
            { val: 3, value: "副总" },
            { val: 4, value: "销售总监" },
            { val: 5, value: "销售经理" },
            { val: 6, value: "财务总监" },
            { val: 7, value: "部长" },
            { val: 8, value: "主任" },
            { val: 9, value: "其他" },
            { val: 10, value: "三方" },
            { val: 11, value: "工程方" },
        ]
    },
    //获取职位类型
    getNameByjobMap(val) {
        let ret = "";
        let tempMap = this.jobMap();
        for (let i = 0; i < tempMap.length; i++) {
            if (val == tempMap[i].val) {
                ret = tempMap[i].value;
                break;
            }
        }
        return ret;
    },
    //获取跟进方式
    getFollowMapCommon() {
        return ["电话", "微信", "面谈", "面谈—到我方公司", "面谈—到甲方公司", "面谈—公共场所", "面谈—到项目参观"]
    },
    //编辑查看页面等级选择
    getCommodityType(jobs) {
        let returnType = [];
        let commodityType = [
            { name: "全部", value: null },
            { name: "拓展", value: 0 },
            { name: "签约礼品", value: 1 },
            { name: "宣传礼品", value: 2 },
            { name: "金蛋礼品", value: 3 },
            { name: "经理送礼", value: 4 },
            { name: "销售日常消耗", value: 5 },
            { name: "固定资产", value: 6 },
            { name: "公司发展", value: 7 },
            { name: "其他", value: 8 },
            { name: "办公室", value: 9 },
            { name: "地锁", value: 10 },
        ]
        commodityType.forEach((element) => {
            jobs.forEach((item) => {
                if (item == element.value) {
                    returnType.push(element)
                }
            });
        });
        return returnType;
    },
    //支付
    payJump(value, callBack) {
        SXApi.call(
            function (suc) {
                callBack && callBack(suc)
            },
            null,
            "FunctionPlugin",
            "pay",
            value
        );
    },
}


// WEBPACK FOOTER //
// ./src/commonjs/utils.js